import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

const NOTES_MAX_LENGTH = 200;

@Component({
  selector: 'app-edit-leave-dialog',
  templateUrl: './edit-leave-dialog.component.html',
  styleUrl: './edit-leave-dialog.component.scss'
})
export class EditLeaveDialogComponent implements OnInit {

  leaveForm: FormGroup;
  today: Date = new Date();

  leaveTypes = ['SickLeave', 'Vacation', 'Personal', 'TimeOff'];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditLeaveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.leaveForm = this.fb.group(
      {
        leaveType: [this.data?.leaveType || '', Validators.required],
        fromDate: [this.data?.fromDate ? new Date(this.data.fromDate) : '', Validators.required],
        toDate: [this.data?.toDate ? new Date(this.data.toDate) : '', Validators.required],
        notes: [this.data?.notes || '', [Validators.maxLength(NOTES_MAX_LENGTH)]]
      },
      { validators: this.dateRangeValidator }
    );
  }

  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const fromDate = group.get('fromDate')?.value;
    const toDate = group.get('toDate')?.value;
    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  get notesMaxLength(): number {
    return NOTES_MAX_LENGTH;
  }

  onSave(): void {
    this.leaveForm.markAllAsTouched();
    if (this.leaveForm.valid) {
      const result = {
        ...this.leaveForm.value,
        notes: this.leaveForm.value.notes || '',
        fromDate: this.formatDateOnly(this.leaveForm.value.fromDate),
        toDate: this.formatDateOnly(this.leaveForm.value.toDate)
      };
      this.dialogRef.close(result);
    } else {
      this.leaveForm.markAllAsTouched();
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  private formatDateOnly(date: Date | string): string {
    const d = date instanceof Date ? date : new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
